import { useEffect, useState } from 'react';
import { supportApi } from '../api/Supportapi';
import SupportTicketDetailStaff from './SupportTicketDetailStaff';
import api from '../api/axios';


const SearchIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-4 h-4">
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.3-4.3" />
  </svg>
);

const STATUS_STYLES = {
  new: 'bg-blue-50 text-blue-600',
  assigned: 'bg-amber-50 text-amber-600',
  in_progress: 'bg-purple-50 text-purple-600',
  resolved: 'bg-[#ECFDF5] text-[#0F8B6D]',
  closed: 'bg-gray-100 text-gray-500',
};

const STATUS_LABELS = {
  new: 'New',
  assigned: 'Assigned',
  in_progress: 'In Progress',
  resolved: 'Resolved',
  closed: 'Closed',
};

const STATUS_FILTERS = [
  { value: '', label: 'All' },
  { value: 'new', label: 'New' },
  { value: 'assigned', label: 'Assigned' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'resolved', label: 'Resolved' },
  { value: 'closed', label: 'Closed' },
];

const ROLE_FILTERS = [
  { value: '', label: 'All Roles' },
  { value: 'job_seeker', label: 'Job Seeker' },
  { value: 'employer', label: 'Employer' },
];

const CATEGORY_FILTERS = [
  '', 'Account Issue', 'Job Application', 'Profile Issue', 'Employer Issue',
  'Job Posting Issue', 'Candidate Issue', 'Employer Verification',
  'Payment Issue', 'Technical Issue', 'Other',
];

export default function SupportTicketsPanel({ Layout }) {
  const [tickets, setTickets] = useState([]);
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [status, setStatus] = useState('');
  const [search, setSearch] = useState('');
  const [selectedId, setSelectedId] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [role, setRole] = useState('');
  const [category, setCategory] = useState('');

  // '' = all, 'mine' = assigned to current agent, 'unassigned' = no agent yet
  const [assignedFilter, setAssignedFilter] = useState('');
  const [assigningId, setAssigningId] = useState(null);

  const [allAgents, setAllAgents] = useState([]);
const [assignModalTicket, setAssignModalTicket] = useState(null);
const [selectedAgentId, setSelectedAgentId] = useState('');
const [modalAssigning, setModalAssigning] = useState(false);





 const currentAgent = (() => {
  try {
    const stored = localStorage.getItem('user');   // ✅ revert to 'user'
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
})();

  const isAdmin = currentAgent?.role === 'admin';

  useEffect(() => {
    if (isAdmin) {
      api.get('/admin/agents').then((res) => setAllAgents(res.data)).catch(() => {});
    }
  }, [isAdmin]);

  const load = () => {
    setLoading(true);
    setError('');
    const assignedParam =
      assignedFilter === 'mine' ? currentAgent?.id
      : assignedFilter === 'unassigned' ? 'unassigned'
      : null;

    supportApi
      .listTickets({
        ...(status ? { status } : {}),
        ...(role ? { user_role: role } : {}),
        ...(category ? { category } : {}),
        ...(search ? { search } : {}),
        ...(assignedParam ? { assigned_to: assignedParam } : {}),
      })
      .then((data) => {
        setTickets(data.data || []);
        setMeta({ total: data.total, current_page: data.current_page, last_page: data.last_page });
      })
      .catch((err) => setError(err.response?.data?.message || err.message))
      .finally(() => setLoading(false));
  };

  useEffect(load, [status, role, category, assignedFilter, refreshKey]);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    load();
  };

const handleAssignToMe = async (e, ticket) => {
  e.stopPropagation();
  if (!currentAgent?.id) {
    setError('Could not identify current agent — please log in again.');
    return;
  }
  setAssigningId(ticket.id);
  try {
    await supportApi.updateTicketStatus(ticket.id, ticket.status, currentAgent.id);
    load();
  } catch (err) {
    if (err.response?.status === 409) {
      setError('Someone just claimed this ticket — refreshing...');
    } else {
      setError(err.response?.data?.message || err.message);
    }
    load(); // refresh so the UI reflects the real assignee
  } finally {
    setAssigningId(null);
  }
};


  const handleModalAssign = async () => {
    if (!selectedAgentId || !assignModalTicket) return;
    setModalAssigning(true);
    try {
      await supportApi.updateTicketStatus(assignModalTicket.id, assignModalTicket.status, Number(selectedAgentId));
      setAssignModalTicket(null);
      setSelectedAgentId('');
      load();
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setModalAssigning(false);
    }
  };

  const Wrapper = Layout || (({ children }) => <>{children}</>);

  if (selectedId) {
    return (
      <SupportTicketDetailStaff
        ticketId={selectedId}
        onBack={() => {
          setSelectedId(null);
          setRefreshKey((k) => k + 1);
        }}
        Layout={Layout}
      />
    );
  }

 return (
    <Wrapper>
    <div className="bg-gradient-to-br from-[#FAF5FC] to-[#FDF1F9] -m-6 p-6 min-h-screen">
         <h1 className="text-2xl font-bold bg-gradient-to-r from-purple-700 to-pink-600 bg-clip-text text-transparent mb-1">Support Tickets</h1>
        <p className="text-sm text-gray-500 mb-6">
          {meta ? `${meta.total} total ticket${meta.total !== 1 ? 's' : ''}` : 'Loading...'}
        </p>

        {/* Filters */}
        <div className="flex flex-wrap items-center gap-2 mb-5">
          {STATUS_FILTERS.map((f) => (
            <button
              key={f.value}
              onClick={() => setStatus(f.value)}
              className={`text-xs font-semibold px-4 py-2 rounded-full border transition ${
               status === f.value ? 'bg-gradient-to-r from-purple-600 to-pink-500 text-white border-transparent shadow-sm' : 'bg-white text-gray-500 border-gray-200 hover:bg-purple-50 hover:text-purple-600'
              }`}
            >
              {f.label}
            </button>
          ))}

          <form onSubmit={handleSearchSubmit} className="ml-auto flex items-center gap-2 bg-white border border-gray-200 rounded-full px-4 py-2.5 text-gray-400 focus-within:ring-2 focus-within:ring-purple-400 focus-within:border-transparent">
            <SearchIcon />
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search subject or ticket #"
              className="text-sm outline-none text-gray-700 w-48"
            />
          </form>
        </div>

        <div className="flex flex-wrap items-center gap-2 mb-5">
          <select
            value={role}
            onChange={(e) => setRole(e.target.value)}
             className="text-xs font-semibold px-3 py-2.5 rounded-xl border border-gray-200 text-gray-600 bg-white focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-transparent"
          >
            <option value="">All Roles</option>
            <option value="job_seeker">Job Seeker</option>
            <option value="employer">Employer</option>
          </select>

          <select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            className="text-xs font-semibold px-3 py-2.5 rounded-xl border border-gray-200 text-gray-600 bg-white focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-transparent"
          >
            <option value="">All Categories</option>
            <option value="Account Issue">Account Issue</option>
            <option value="Job Application">Job Application</option>
            <option value="Profile Issue">Profile Issue</option>
            <option value="Employer Issue">Employer Issue</option>
            <option value="Job Posting Issue">Job Posting Issue</option>
            <option value="Candidate Issue">Candidate Issue</option>
            <option value="Employer Verification">Employer Verification</option>
            <option value="Payment Issue">Payment Issue</option>
            <option value="Technical Issue">Technical Issue</option>
            <option value="Other">Other</option>
          </select>

          <select
            value={assignedFilter}
            onChange={(e) => setAssignedFilter(e.target.value)}
            className="text-xs font-semibold px-3 py-2.5 rounded-xl border border-gray-200 text-gray-600 bg-white focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-transparent"
          >
            <option value="">All Tickets</option>
            <option value="mine">My Tickets</option>
            <option value="unassigned">Unassigned</option>
          </select>
        </div>

        {loading && <p className="text-sm text-gray-400 py-10 text-center">Loading tickets...</p>}
        {error && <div className="bg-red-50 text-red-600 text-sm rounded-xl p-3 mb-4 border border-red-100">{error}</div>}
        {!loading && !error && tickets.length === 0 && (
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-10 text-center text-sm text-gray-400">No tickets match this filter.</div>
        )}

        {/* Table */}
        {!loading && tickets.length > 0 && (
          <div className="bg-white border border-gray-100 rounded-2xl shadow-sm overflow-hidden">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-gray-100 text-left text-[10px] text-gray-400 uppercase bg-gray-50/60">
                  <th className="px-4 py-3 font-semibold">Ticket</th>
                  <th className="px-4 py-3 font-semibold">Subject</th>
                  <th className="px-4 py-3 font-semibold">Category</th>
                  <th className="px-4 py-3 font-semibold">Role</th>
                  <th className="px-4 py-3 font-semibold">Status</th>
                  <th className="px-4 py-3 font-semibold">Assigned To</th>
                  <th className="px-4 py-3 font-semibold">Created</th>
                </tr>
              </thead>
              <tbody>
                {tickets.map((t) => (
                  <tr
                    key={t.id}
                    onClick={() => setSelectedId(t.id)}
                    className="border-b border-gray-50 last:border-0 hover:bg-purple-50/30 cursor-pointer transition-colors"
                  >
                    <td className="px-4 py-3 font-semibold text-purple-600 whitespace-nowrap">{t.ticket_number}</td>
                    <td className="px-4 py-3 text-gray-700 max-w-[220px] truncate">{t.subject}</td>
                    <td className="px-4 py-3 text-gray-500 whitespace-nowrap">{t.category}</td>
                    <td className="px-4 py-3 text-gray-500 capitalize whitespace-nowrap">{t.user_role?.replace('_', ' ')}</td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      <span className={`text-[10px] font-semibold px-2.5 py-0.5 rounded-full whitespace-nowrap ${STATUS_STYLES[t.status] || 'bg-gray-50 text-gray-500'}`}>
                        {STATUS_LABELS[t.status]}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-gray-500 whitespace-nowrap">
                      <div className="flex items-center gap-2">
                        {t.assigned_agent?.name && <span>{t.assigned_agent.name}</span>}
                        {!isAdmin && (
                          <button
                            onClick={(e) => handleAssignToMe(e, t)}
                            disabled={assigningId === t.id}
                            className="text-[10px] font-semibold text-emerald-600 hover:underline disabled:opacity-50 disabled:no-underline"
                          >
                            {assigningId === t.id
                              ? 'Assigning...'
                              : t.assigned_agent?.name
                              ? 'Reassign to me'
                              : 'Assign to me'}
                          </button>
                        )}
                        {isAdmin && (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setAssignModalTicket(t);
                            }}
                            className="text-[10px] font-semibold text-purple-600 hover:underline"
                          >
                            Assign agent ▾
                          </button>
                        )}
                      </div>
                    </td>

                    <td className="px-4 py-3 text-gray-400 whitespace-nowrap">
                      {new Date(t.created_at).toLocaleDateString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
    </div>

    {assignModalTicket && (
      <div
        className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4"
        onClick={() => setAssignModalTicket(null)}
      >
        <div
         className="bg-white rounded-2xl shadow-xl max-w-sm w-full p-6"
          onClick={(e) => e.stopPropagation()}
        >
          <h3 className="text-lg font-bold bg-gradient-to-r from-purple-700 to-pink-600 bg-clip-text text-transparent mb-1">Assign ticket</h3>
          <p className="text-xs text-gray-500 mb-4">{assignModalTicket.ticket_number}</p>
          <select
            value={selectedAgentId}
            onChange={(e) => setSelectedAgentId(e.target.value)}
             className="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm mb-4 focus:outline-none focus:ring-2 focus:ring-purple-400"
          >
            <option value="">Select an agent...</option>
            {allAgents.map((a) => (
              <option key={a.id} value={a.id}>{a.name}</option>
            ))}
          </select>
          <div className="flex gap-2 justify-end">
            <button
              onClick={() => setAssignModalTicket(null)}
              className="text-xs font-semibold text-gray-500 px-4 py-2 rounded-full hover:bg-gray-100"
            >
              Cancel
            </button>
            <button
              onClick={handleModalAssign}
              disabled={!selectedAgentId || modalAssigning}
              className="text-xs font-semibold text-white bg-gradient-to-r from-purple-600 to-pink-500 px-5 py-2 rounded-full shadow-sm disabled:opacity-50 hover:opacity-90 transition"
            >
              {modalAssigning ? 'Assigning...' : 'Assign'}
            </button>
          </div>
        </div>
      </div>
    )}
    </Wrapper>
  );
}